let state = {
	carat: '0.3',
	qualityId: 1,
	defaultStockSearch: {
		certificateNo:   0,
		certificate: 	  '1',
		form: 			    'A',
		carat: 			    ['0.3', '5.0'],
		color: 			    ['7_id', ''],
		fluorescence: 	['4_id', ''],
		polish:			    ['3_id', ''],
		symmetry: 		  ['3_id', ''],
		purity:			    ['1_id', ''],
		finish:			    ['3_id', ''],
		stoneIds: 		  false,
		price:			    '100',
	},
	diamondStockSearch: {
		certificateNo:   0,
		certificate: 	  '1-2-3',
		form: 			    'A',
		carat: 			    ['0.3', '5.0'],
		color: 			    ['6_id', ''],
		fluorescence: 	['6_id', ''],
		polish:			    ['1_id', ''],
		symmetry: 		  ['5_id', ''],
		purity:			    ['1_id', ''],
		finish:			    ['1_id', ''],
		stoneIds: 		  false,
		price:			    '100',
	},
	labGrownSearch: {
		certificateNo:   0,
		certificate: 	  '1-2-3',
		form: 			    'A',
		carat: 			    ['0.3', '5.0'],
		color: 			    ['9_id', ''],
		fluorescence: 	['6_id', ''],
		polish:			    ['3_id', ''],
		symmetry: 		  ['3_id', ''],
		purity:			    ['3_id', ''],
		finish:			    ['3_id', ''],
		stoneIds: 		  false,
		price:			    '100',
	},
	navSite: 1,
	moreSearch: false,
}

let actions =  {
	setCarat(context, carat) {
		context.commit('setCarat', carat);
		context.commit('setDefaultStockSearch', {carat: carat});
		context.commit('setDiamondStockSearchCarat', carat);
		context.commit('setLabGrownSearchCarat', carat);

	},
	setStoneIds(context, showWishlist) {
		context.commit('setStoneIds', showWishlist);
	},
	setQualityId(context, id) {
		context.commit('setQualityId', id);
	},
	setDefaultStockSearch(context, search) {
		context.commit('setDefaultStockSearch', search);
	},
	setDiamondStockSearch(context, search) {
		context.commit('setDiamondStockSearch', search);
	},
	setNavSite(context, site) {
		context.commit('setNavSite', site);
	},
	setMoreSearch(context, moreSearch) {
		context.commit('setMoreSearch', moreSearch);
	}
}

let mutations =  {
	setCarat(state, carat) {
		if (state.carat !== carat) {
			state.carat = carat;
		}
	},
	setQualityId(state, id) {
		if (state.qualityId !== id) {
			state.qualityId = id;
		}
	},
	setStoneIds(state, showWishlist) {
		if (typeof showWishlist === 'boolean') {
			state.defaultStockSearch.stoneIds = showWishlist;
			state.diamondStockSearch.stoneIds = showWishlist;
		}
	},
	setDefaultStockSearch(state, search) {
		for (const [key, value] of Object.entries(search)) {
			if (state.defaultStockSearch[key] !== value) {
				state.defaultStockSearch[key][0] = value;
			}
		}
	},
	setDiamondStockSearch(state, search) {
		for (const [key, value] of Object.entries(search)) {
			if (state.diamondStockSearch[key] !== value) {
				state.diamondStockSearch[key] = value;
			}
		}
	},
	/*setLabGrownSearch(state, search) {
		for (const [key, value] of Object.entries(search)) {
			if (state.labGrownSearch[key] !== value) {
				state.labGrownSearch[key] = value;
			}
		}
	},*/
	setDiamondStockSearchCarat(state, carat) {
		if (state.diamondStockSearch['carat'][0] !== carat) {
			state.diamondStockSearch['carat'][0] = carat;
		}
	},
	setLabGrownSearchCarat(state, carat) {
		if (state.labGrownSearch['carat'][0] !== carat) {
			state.labGrownSearch['carat'][0] = carat;
		}
	},
	setNavSite(state, site) {
		if (state.navSite !== site) {
			state.navSite = site;
		}
	},
	setMoreSearch(state, moreSearch) {
		if (moreSearch === true || moreSearch === false) {
			state.moreSearch = moreSearch;
		}
	}
}

let getters =  {
	getCarat: state => {
		return state.carat;
	},
	getQualityId: state => {
		return state.qualityId;
	},
	getDefaultStockSearch: state => {
		return state.defaultStockSearch;
	},
	getDiamondStockSearch: state => {
		return state.diamondStockSearch;
	},
	getLabGrownSearch: state => {
		return state.labGrownSearch;
	},
	getNavSite: state => {
		return state.navSite;
	},
	getMoreSearch: state => {
		return state.moreSearch;
	}
}
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}
